export default __webpack_public_path__ + "static/media/blagovaonski.86c86ad6.jpg";